var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClickIcon = function SvgClickIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-click",
    viewBox: "0 0 24 24",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12l3 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3l0 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 7.8l-2.2 -2.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 7.8l2.2 -2.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 16.2l-2.2 2.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12l9 3l-4 2l-2 4l-3 -9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClickIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1vdXRsaW5lIGljb24tdGFibGVyLWNsaWNrIj48cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+PHBhdGggZD0iTTMgMTJsMyAwIiAvPjxwYXRoIGQ9Ik0xMiAzbDAgMyIgLz48cGF0aCBkPSJNNy44IDcuOGwtMi4yIC0yLjIiIC8+PHBhdGggZD0iTTE2LjIgNy44bDIuMiAtMi4yIiAvPjxwYXRoIGQ9Ik03LjggMTYuMmwtMi4yIDIuMiIgLz48cGF0aCBkPSJNMTIgMTJsOSAzbC00IDJsLTIgNGwtMyAtOSIgLz48L3N2Zz4=";